var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "form"
  }, [_c("el-form", {
    ref: "form",
    staticClass: "form-content",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "right",
      "label-width": "140px",
      size: "mini"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 15
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "截止日期",
      prop: "c12Time"
    }
  }, [_c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: _vm.id,
      type: "date",
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择截止日期"
    },
    model: {
      value: _vm.form.c12Time,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c12Time", $$v);
      },
      expression: "form.c12Time"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "日期类型",
      prop: "c12TimeType"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.c12TimeType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c12TimeType", $$v);
      },
      expression: "form.c12TimeType"
    }
  }, [_c("el-radio", {
    attrs: {
      label: "截止"
    }
  }, [_vm._v("截止")]), _c("el-radio", {
    attrs: {
      label: "期间"
    }
  }, [_vm._v("期间")])], 1)], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 15
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "科目名称",
      prop: "c12AccountName"
    }
  }, [_c("cpsc-select", {
    staticClass: "select app-form-component-select",
    attrs: {
      filterable: "",
      disabled: _vm.id,
      placeholder: "请选择科目名称"
    },
    model: {
      value: _vm.form.c12AccountName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c12AccountName", $$v);
      },
      expression: "form.c12AccountName"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c("el-option", {
      key: item.n04Id,
      attrs: {
        label: item.n04Value,
        value: item.n04Value
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: _vm.text,
      prop: "c12AccountSum"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "\u8BF7\u8F93\u5165".concat(_vm.text)
    },
    model: {
      value: _vm.form.c12AccountSum,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "c12AccountSum", $$v);
      },
      expression: "form.c12AccountSum"
    }
  })], 1)], 1)], 1), _vm.type !== "new" ? [_c("el-row", {
    attrs: {
      gutter: 15
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "本科目发函合计数"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.c12ConfirmSendSum) + " ")])], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "发函比例"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.c12ConfirmSendRatio) + " ")])], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 15
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "本科目回函合计数"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.c12ConfirmBackSum) + " ")])], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "回函比例"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.c12ConfirmBackRatio) + " ")])], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 15
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "最后编辑人"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.c12StaffName) + " ")])], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "编辑日期"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("date")(_vm.form.c12EditDate, "yyyy-MM-dd")) + " ")])], 1)], 1)] : _vm._e()], 2), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };